import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './inspektoratverwaltung.module.scss';
import {inspektoratverwaltungRun} from './inspektoratverwaltung.route';
import {InspektoratverwaltungViewComponentConfig} from './component/inspektoratverwaltungView/inspektoratverwaltungView';
import {InspektoratViewComponentConfig} from './component/inspektoratView/inspektoratView';

export const SerfWebInspektoratverwaltung = angular.module('serfWeb.inspektoratverwaltung', [SerfWebCore.name])
    .component('dvInspektoratverwaltungView', new InspektoratverwaltungViewComponentConfig())
    .component('dvInspektoratView', new InspektoratViewComponentConfig())
    .run(inspektoratverwaltungRun);

export default SerfWebInspektoratverwaltung;



// WEBPACK FOOTER //
// ./src/app/inspektoratverwaltung/inspektoratverwaltung.module.ts